import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';
import type { AdminMeResponse } from '@/lib/api-admin';

export const myAccountQueryKey = ['admin', 'me'] as const;

export const useMyAccountQuery = () =>
  useQuery<AdminMeResponse>({
    queryKey: myAccountQueryKey,
    queryFn: async () => {
      const [data] = await apiClient.request('get', '/admin/v1/me', {});
      return data as AdminMeResponse;
    },
  });
